import { SmileOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logEvent } from "src/analytics/amplitude";
import { useConfirmation } from "../context/confirmation";
import InstructionsForm from "./InstructionsForm";
import styled from "styled-components";
import { getDashboardURL } from "src/weirdStuff";

const StyledActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto !important;
  gap: 10px;
  max-width: 300px;
  flex-wrap: wrap;
  a.ant-btn {
    padding: 2px !important;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Confirmation = ({ changePage }) => {
  const { clean_date, total_amount, email, source } = useConfirmation();
  const [showInstructionsForm, setShowInstructionsForm] = useState(false);
  const [instructionsFormComplete, setInstructionsFormComplete] =
    useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!clean_date || !total_amount || !email) {
      changePage(1);
      // @ts-expect-error gtag might be undefined
      gtag?.("event", "Booking_Failed");
      debugger;
      navigate("/");
    } else {
      // @ts-expect-error gtag might be undefined
      gtag?.("event", "Booking_Done");
      logEvent("User was directed to the confirmation page", {
        email,
        clean_date,
        total_amount,
      });
    }
    window.onbeforeunload = null;
  }, [clean_date, total_amount, changePage, email, navigate, source]);

  const handleInstructionsFormComplete = () => {
    setShowInstructionsForm(false);
    setInstructionsFormComplete(true);
  };

  const title = useMemo(() => {
    if (source === "bookings") {
      return "Reservation confirmed!";
    } else {
      return "Tasks Booked!";
    }
  }, [source]);

  const subTitle = useMemo(() => {
    if (source === "bookings") {
      return `Your cleaning and disinfection service is ready for you!
          We'll see you on ${moment(clean_date).format("ll")}`;
    } else {
      return `Your tasks are ready for you!
          We'll see you on ${moment(clean_date).format("ll")}`;
    }
  }, [clean_date, source]);

  if (instructionsFormComplete) {
    return (
      <div>
        <Result
          icon={<SmileOutlined twoToneColor="#00b6de" />}
          status="success"
          title="Instructions added successfully!"
          subTitle="We'll use these instructions to clean your home."
          style={{ padding: 0, marginTop: 40 }}
          extra={
            <StyledActions>
              <Button
                size="large"
                type="primary"
                className="next-button w-full"
                href={getDashboardURL(
                  "booking-app",
                  "confirmation-page",
                  source
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                Go to my booking
              </Button>
              <div
                style={{
                  flex: 1,
                  flexBasis: "100%",
                  flexDirection: "column",
                  gap: 24,
                  marginTop: 40,
                }}
              >
                <Button
                  type="link"
                  size="large"
                  href="https://heyhomero.com/contact"
                  className="link"
                >
                  Contact support
                </Button>
              </div>
            </StyledActions>
          }
        />
      </div>
    );
  }

  if (showInstructionsForm) {
    return <InstructionsForm onComplete={handleInstructionsFormComplete} />;
  }

  return (
    <div>
      <Result
        icon={<SmileOutlined twoToneColor="#00b6de" />}
        status="success"
        title={title}
        subTitle={subTitle}
        style={{ padding: 0, marginTop: 40 }}
        extra={
          <StyledActions>
            <Button
              size="large"
              type="primary"
              style={{ padding: 8 }}
              className="next-button w-full"
              href={getDashboardURL("booking-app", "confirmation-page")}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to my booking
            </Button>
            {source === "bookings" && (
              <Button
                size="large"
                type="default"
                className="next-button back-button w-full"
                onClick={() => {
                  setShowInstructionsForm(true);
                }}
              >
                Add cleaning instructions
              </Button>
            )}
            <div
              style={{
                flex: 1,
                flexBasis: "100%",
                flexDirection: "column",
                gap: 24,
                marginTop: 40,
              }}
            >
              <Button
                type="link"
                size="large"
                href="https://heyhomero.com/contact"
                className="link"
              >
                Contact support
              </Button>
            </div>
          </StyledActions>
        }
      />
    </div>
  );
};

export default Confirmation;
